import { OKVItemType } from 'components/ContentElementsGdds/online-catalog-assets';

type ProductDeprecatedPlaceholderProps = {
  product: string;
  tileType?: typeof OKVItemType[keyof typeof OKVItemType];
};

export function ProductDeprecatedPlaceholder({
  product,
  tileType = OKVItemType.Product,
}: Readonly<ProductDeprecatedPlaceholderProps>) {
  return (
    <div className="c-product-tile--deprecated">
      <div>{product}</div>
      <div>{`${capitalizeFirstLetter(tileType)} not available`}</div>
    </div>
  );
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
